import React, { useState } from "react";
import { Button } from "primereact/button";
import veglabel from "../../assets/images/icon/veg.png";
import nonveg from "../../assets/images/non-vegetarian-sign-veg-logo-symbol-vector-50890043.jpg";
const Ordercard = ({ serviceType, data, onCancel, eventId }) => {
  const [expandedIndexes, setExpandedIndexes] = useState({}); // store expanded state per tent index
  const [openMenuRow, setOpenMenuRow] = useState(null);
  const toggleExpand = (idx) => {
    setExpandedIndexes((prev) => ({
      ...prev,
      [idx]: !prev[idx],
    }));
  };

  if (!data || data.length === 0) return null;

  switch (serviceType) {
    
    case "Priest":
      return (
        <div className="Order_service-card">
          {data.map((priest, idx) => (
            <div key={idx} className="Order_service-item">
              <div className="order_headder">
                <span className="providername">
                  {priest.priest.name}
                </span>
                <div className="cancleblock">

                  <div style={{ position: "relative" }}>
                    {/* 3-dots button */}
                    <Button
                      icon="pi pi-ellipsis-v"
                      className="p-button-rounded p-button-text"
                      style={{ backgroundColor: "#fff", color: "#000", border: "1px solid #ccc" }}
                      onClick={() =>
                        setOpenMenuRow(openMenuRow === priest.priest.id ? null : priest.priest.id)
                      }
                    />

                    {/* Conditional menu container */}
                    {openMenuRow === priest.priest.id && (
                      <div
                        className="dropdownContainer"
                        style={{
                          position: "absolute",
                          top: "100%",
                          right: 0,
                          background: "#fff",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          padding: "5px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "5px",
                          zIndex: 100,
                          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                        }}
                      >
                        <button
                          className="cancel-btn"
                          onClick={() => {
                            onCancel({ eventId, provider_id: priest.priest.id, serviceType });
                            setOpenMenuRow(null); // close menu after action
                          }}
                        >
                          <i className="pi pi-times"></i> Cancel
                        </button>
                      </div>
                    )}
                  </div>

                </div>
              </div>
              <div className="footer">
                <span></span>
                <span className="Bill_total">Bill Total ₹{priest.total_amount}</span>
              </div>
            </div>
          ))}
        </div>
      );

    case "Tent House":
      return (
        <div className="Order_service-card">
          {data.map((tent, idx) => {
            const isExpanded = expandedIndexes[idx];
            const visibleItems = isExpanded ? tent.items : tent.items?.slice(0, 2);

            return (
              <div key={idx} className="Order_service-item">
                <div className="order_headder">
                  <span className="providername">
                    {tent.first_name} {tent.last_name}
                  </span>
                  <div className="cancleblock">
                    <div style={{ position: "relative" }}>
                      {/* 3-dots button */}
                      <Button
                        icon="pi pi-ellipsis-v"
                        className="p-button-rounded p-button-text"
                        style={{ backgroundColor: "#fff", color: "#000", border: "none" }}
                        onClick={() =>
                          setOpenMenuRow(openMenuRow === tent.provider_id ? null : tent.provider_id)
                        }
                      />

                      {/* Conditional menu container */}
                      {openMenuRow === tent.provider_id && (
                        <div
                          className="dropdownContainer"
                          style={{
                            position: "absolute",
                            top: "100%",
                            right: 0,
                            background: "#fff",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            padding: "5px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "5px",
                            zIndex: 100,
                            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                          }}
                        >
                          <button
                            className="cancel-btn"
                            onClick={() => {
                              onCancel({ eventId, provider_id: tent.provider_id, serviceType });
                              setOpenMenuRow(null); // close menu after action
                            }}

                          >
                            <i className="pi pi-times"></i> Cancel
                          </button>
                        </div>
                      )}
                    </div>
                    {/* <button
                className="cancel-btn"
                onClick={() =>
                  onCancel({ eventId, provider_id: tent.provider_id, serviceType })
                }
              >
                <i className="pi pi-times"></i>
                Cancel
              </button> */}

                  </div>
                </div>
                {visibleItems?.map((item, i) => (
                  <span key={i} className="tentitemslist">
                    {item.mapping.service.service_name} (x{item.quantity})
                  </span>
                ))}

                {tent.items?.length > 2 && (
                  <button
                    onClick={() => toggleExpand(idx)}
                    className="expand-btn"
                  >
                    {isExpanded ? "Show Less" : `+${tent.items.length - 2} more`}
                  </button>
                )}

                <div className="footer">
                  <span></span>
                  <span className="Bill_total">Bill Total ₹{tent.total_amount}</span>
                </div>
              </div>
            );
          })}
        </div>
      );

    case "Catering":
      return (
        <div className="Order_service-card">
          {data.map((cater, idx) => {
            const isveg = cater.items[0].category.category_name == "Vegetarian"
            const categoryImage = isveg ? veglabel : nonveg
            return (
              <div key={idx} className="Order_service-item">
                <div className="cateringheader">
                  <span className="providername">
                    {cater.first_name} {cater.last_name}
                  </span>



                  <div className="cancleblock">
                    <div className="icon image">
                      <img src={categoryImage} alt="Category Icon" className="categoryIcon" />
                    </div>
                    {/* <button
                className="cancel-btn"
                onClick={() =>
                  onCancel({ eventId, provider_id: cater.provider_id, serviceType })
                }
              >
                <i className="pi pi-times"></i>
                Cancel
              </button> */}
                    <div style={{ position: "relative" }}>
                      {/* 3-dots button */}
                      <Button
                        icon="pi pi-ellipsis-v"
                        className="p-button-rounded p-button-text"
                        style={{ backgroundColor: "#fff", color: "#000", border: "none", padding: "1px", alignItems: "first baseline" }}
                        onClick={() =>
                          setOpenMenuRow(openMenuRow === cater.provider_id ? null : cater.provider_id)
                        }
                      />

                      {/* Conditional menu container */}
                      {openMenuRow === cater.provider_id && (
                        <div
                          className="dropdownContainer"
                          style={{
                            position: "absolute",
                            top: "100%",
                            right: 0,
                            background: "#fff",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            padding: "5px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "5px",
                            zIndex: 100,
                            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                          }}
                        >
                          <button
                            className="cancel-btn"
                            onClick={() => {
                              onCancel({ eventId, provider_id: cater.provider_id, serviceType });
                              setOpenMenuRow(null); // close menu after action
                            }}

                          >
                            <i className="pi pi-times"></i> Cancel
                          </button>
                        </div>
                      )}
                    </div>
                  </div>

                </div>

                {cater.items?.map((dish, i) => (
                  <span key={i} className="cateringitemslist">
                    {dish.meal.meal_name} ({dish.type.type_name})
                    {dish.mapping?.regular_price}

                    <span>Total no people</span> {dish.number_of_people}
                  </span>
                ))}


                <div className="footer">
                  <span></span>
                  <span className="Bill_total">Bill Total ₹{cater.total_amount}</span>
                </div>
              </div>
            )
          })}
        </div>
      );

    default:
      return null;
  }
};

export default Ordercard;
